module.exports = __webpack_public_path__ + "static/img/00.1f673f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/05/00.jpg
// module id = lSBI
// module chunks = 0